<template>

  <div class="card card-info">
    <div class="card-header with-border" style="font-weight:bold">
      <h3 class="card-title">Eligible /In-Eligible Candidates</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          Session
          <select class="form-control" v-model="semesterID">
            <option value="0">--Select Session--</option>
            <option v-for="item in semester" v-bind:value="item.ID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          Degree
          <select class="form-control" v-model="degreeID" v-on:change="loadPrograms()">
            <option value="0">--Select Degree--</option>
            <option v-for="item in degree" v-bind:value="item.ID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          Program
          <select class="form-control" v-model="programID">
            <option value="0">--Select Program--</option>
            <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
          </select>
        </div>

        <div class="col-md-4">
          Type<br />
          <select class="form-control" v-model="type">
            <option :value="true">Eligible</option>
            <option :value="false">Not-Eligible</option>
          </select>
        </div>
      </div>
      <div v-show="screen === 'enabled'">
        <label>{{type == true ? 'Eligible' : 'In-Eligible'}} Candidates</label>


        <div class="row">
          <div class="col-md-12 ">
            <div class="table-responsive">
              <table class="table table-striped table-bordered table-sm">
                <thead class="bg-info text-white">
                  <tr>
                    <th width="5%" style="text-align: center">
                      Sr.No
                    </th>
                    <th width="20%" style="text-align: center">
                      Name
                    </th>
                    <th width="20%" style="text-align: center">
                      Father Name
                    </th>

                    <th width="20%" style="text-align: center">
                      Program
                    </th>

                    <th width="35%" style="text-align: center">
                      Remarks
                    </th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in students">
                    <td>{{ind+1}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.FathersName}}</td>
                    <td>{{item.Program}}</td>
                    <td>{{item.Remarks}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div class="card-footer bg-light" style="text-align: right">
      <button class="btn btn-success" type="button" id="showTbale" v-on:click="loadstudents()">View</button>
      <a :href="'/Admission/InEligibileCandidatesPrint?sem=' + semesterID + '&deg=' + degreeID + '&prog=' + programID + '&type=' + type" id="print" class="btn btn-primary" v-if="screen === 'enabled'" target="_blank">Print</a>
      <button class="btn btn-danger" v-on:click="clear()">Clear</button>
    </div>
  </div>
  <!--<div class="card card-info">
    <div class="card-header" style="font-weight:bold">
      <h3 class="card-title">{{type == true ? 'Eligible' : 'In-Eligible'}} Candidates</h3>
    </div>
    <div class="card-body ">
      <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12">
        <div class="form-row">
          <div class="col-md-12 ">
            <table style="border: 1px solid black;width:100%" class="table table-bordered table-color">
              <thead>
                <tr>
                  <th width="5%" style="text-align: center">
                    Sr.No
                  </th>
                  <th width="20%" style="text-align: center">
                    Name
                  </th>
                  <th width="20%" style="text-align: center">
                    Father Name
                  </th>

                  <th width="20%" style="text-align: center">
                    Program
                  </th>

                  <th width="35%" style="text-align: center">
                    Remarks
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in students">
                  <td>{{ind+1}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.FathersName}}</td>
                  <td>{{item.Program}}</td>
                  <td>{{item.Remarks}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br />
      </div>
      <br />
    </div>
  </div>-->
</template>

<script>

  const axios = require('axios').default;
  export default ({
    data() {
      return {
        type: true,
        semester: [],
        degree: [],
        program: [],
        semesterID: 0,
        degreeID: 0,
        programID: 0,
        screen: 'disable',
        students: [],
      }
    },

    created: function () {
      this.loadsemester();

    },

    methods: {
      loadsemester: function () {

        var vm = this;
        axios.post('/api/AdmissionApi/loaddataofrecheckinglist')
          .then(function (res) {
            vm.degree = res.data.degree;
            vm.semester = res.data.semester;
            //vm.header = res.data["header"];
          })
          .then(function (error) {
            console.log(error);
          })
      },
      clear() {
        location.reload();
      },

      loadPrograms() {

        var vm = this;
        axios.post('/api/AdmissionApi/loadprogramsofcheckinglist?ID=' + vm.degreeID + '&semID=' + vm.semesterID)
          .then(function (res) {
            vm.program = res.data.pro;
          })
          .then(function (error) {
            console.log(error);
          })
      },



      loadstudents: function () {
        var vm = this;
        if (vm.semesterID == 0 || vm.semesterID == '') {
          toastr.error("select Semester");
          return;
        }
        if (vm.degreeID == 0 || vm.degreeID == '') {
          toastr.error("select Degree");
          return;
        }
        axios.post('/api/AdmissionApi/loadstudents?sem=' + vm.semesterID + '&deg=' + vm.degreeID + '&prog=' + vm.programID + '&typ=' + vm.type)
          .then(function (res) {
              vm.students = res.data['lst'];
              vm.screen = 'enabled';
           
          })
          .catch(function (error) {
            console.log(error);
          });
      },


    }

  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/inEligibileCandidates.vue